"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InmemoryLogger = void 0;
const log_level_1 = require("./log-level");
class InmemoryLogger {
    level;
    tags;
    parent;
    entries = [];
    constructor(level = log_level_1.LogLevel.DEBUG, tags = [], parent) {
        this.level = level;
        this.tags = tags;
        this.parent = parent;
    }
    isDebugEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.DEBUG);
    }
    debug(message, ...args) {
        this.log(log_level_1.LogLevel.DEBUG, message, args);
    }
    isInfoEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.INFO);
    }
    info(message, ...args) {
        this.log(log_level_1.LogLevel.INFO, message, args);
    }
    isWarnEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.WARN);
    }
    warn(message, ...args) {
        this.log(log_level_1.LogLevel.WARN, message, args);
    }
    isErrorEnabled() {
        return this.isLevelEnabled(log_level_1.LogLevel.ERROR);
    }
    error(message, ...args) {
        this.log(log_level_1.LogLevel.ERROR, message, args);
    }
    child(tag) {
        return new InmemoryLogger(this.level, [...this.tags, tag], this.getRootLogger());
    }
    // Test helper methods
    getEntries(level) {
        if (level === undefined) {
            return [...this.entries];
        }
        return this.entries.filter(entry => entry.level === level);
    }
    getMessages(level) {
        return this.getEntries(level).map(entry => {
            const levelStr = log_level_1.LogLevel[entry.level];
            const tagsStr = entry.tags.length ? `[${entry.tags.join('/')}] ` : '';
            const argsStr = entry.args.length
                ? ' ' +
                    entry.args
                        .map(arg => {
                        if (arg instanceof Error) {
                            return arg.message;
                        }
                        return JSON.stringify(arg);
                    })
                        .join(' ')
                : '';
            return `${levelStr}: ${tagsStr}${entry.message}${argsStr}`;
        });
    }
    getLastEntry() {
        return this.entries[this.entries.length - 1];
    }
    clearEntries() {
        this.entries = [];
    }
    isLevelEnabled(testedLevel) {
        return testedLevel >= this.level;
    }
    getRootLogger() {
        let current = this;
        while (current.parent) {
            current = current.parent;
        }
        return current;
    }
    log(level, message, args) {
        if (!this.isLevelEnabled(level)) {
            return;
        }
        const entry = {
            level,
            message,
            args,
            tags: [...this.tags],
        };
        if (this.parent) {
            this.parent.entries.push(entry);
        }
        else {
            this.entries.push(entry);
        }
    }
}
exports.InmemoryLogger = InmemoryLogger;
//# sourceMappingURL=data:application/json;base64,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